import { render, staticRenderFns } from "./BacVideoPlayer.vue?vue&type=template&id=7a98250f&"
import script from "./BacVideoPlayer.vue?vue&type=script&lang=ts&"
export * from "./BacVideoPlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports